import {
  getGroupAllTripsInfo,
  getGroupDashboard,
  getGroupDashboardActiveTrips,
  getMembersReport,
  getPatientsStat,
  getProjectsNeededAction,
  getTotalReceptedPatients,
} from "@/api/group";
import { Loader } from "@/components";
import { Tab, Tabs } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import AllTripsInfo from "./AllTripsInfo";
import CurrentReport from "./CurrentReport";
import GroupMembersReport from "./GroupMembersReport";
import PersonalInfo from "./PersonalInfo";
import ProjectsNeededAction from "./ProjectsNeededAction";
import PatientsStat from "./PatientsStat";

const styleSelected = {
  fontSize: "16px !important",
  color: "white !important",
  backgroundColor: "var(--emr-darkblue) !important",
  cursor: "pointer",
  transition: "0.2s all",
  borderRadius: "8px !important",
  padding: "4px 8px !important",
};
const styleNotSelected = {
  fontSize: "14px !important",
  color: "var(--emr-disable) !important",
  cursor: "pointer",
  transition: "0.2s all !important",
};

export default function DashboardGroup({ level, data, leader }) {
  const [activeTripsStats, setActiveTripsStats] = useState();
  const [allTripsInfo, setAllTripsInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [membersReport, setMembersReport] = useState();
  const [totalRecepted, setTotalRecepted] = useState();
  const [tripTables, setTripTables] = useState();
  const [projectsNeededAction, setProjectsNeededAction] = useState();
  const [patientsStat, setPatientsStat] = useState();

  const fetchMembersData = useCallback(() => {
    getMembersReport()
      .then((res) => setMembersReport(res))
      .finally(() => setLoading(false));
  }, []);

  const fetchProjectsNeededAction = useCallback(() => {
    getProjectsNeededAction().then((res) => setProjectsNeededAction(res));
  }, []);

  const fetchTotalRecepted = useCallback(() => {
    getTotalReceptedPatients().then((res) => setTotalRecepted(res));
  }, []);

  const fetchPatientsStat = useCallback(() => {
    setLoading(true);
    getPatientsStat()
      .then((res) => {
        setPatientsStat(res);
      })
      .finally(() => setLoading(false));
  }, []);

  const fetchCurrentTripsReport = useCallback(() => {
    setLoading(true);
    getGroupDashboardActiveTrips()
      .then((res) => {
        if (res.activeTrips && res.activeTrips.length > 0)
          setActiveTripsStats(res.activeTrips);
      })
      .finally(() => setLoading(false));
  });

  const [selectedTab, setSelectedTab] = useState("personal");

  const fetchAllTripsInfo = useCallback(() => {
    setLoading(true);
    getGroupAllTripsInfo()
      .then((res) => setAllTripsInfo(res))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const fetchTrips = useCallback(() => {
    setLoading(true);
    getGroupDashboard()
      .then((res) => setTripTables(res))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (selectedTab === "allTripsInfo") {
      if (allTripsInfo) return;
      fetchAllTripsInfo();
    } else if (selectedTab === "members") {
      if (membersReport) return;
      fetchMembersData();
    } else if (selectedTab === "currentTripsReport") {
      if (activeTripsStats) return;
      fetchCurrentTripsReport();
    } else if (selectedTab === "personal") {
      if (totalRecepted) return;
      fetchTotalRecepted();
      fetchTrips();
    } else if (selectedTab === "patients") {
      if (patientsStat) return;
      fetchPatientsStat();
    }
  }, [selectedTab]);

  useEffect(() => {
    fetchProjectsNeededAction();
  }, []);

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={(_, newValue) => {
          setSelectedTab(newValue);
        }}
        sx={{
          backgroundColor: "var(--emr-background-silver)",
          padding: "6px 12px",
          borderRadius: "8px",
          overflow: "auto",
          mt: "10px",
          "& .MuiTabs-indicator": {
            bgcolor: "white",
          },
          "& .MuiTabs-flexContainer": {
            overflow: "auto",
          },
        }}
      >
        <Tab
          label="اطلاعات شخصی"
          value={"personal"}
          sx={selectedTab === "personal" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("personal")}
        />
        <Tab
          label="مدیریت اردوهای جاری"
          value={"currentTripsReport"}
          sx={
            selectedTab === "currentTripsReport"
              ? styleSelected
              : styleNotSelected
          }
          onClick={() => setSelectedTab("currentTripsReport")}
        />
        <Tab
          label="رصد کل اردوها"
          value={"allTripsInfo"}
          sx={selectedTab === "allTripsInfo" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("allTripsInfo")}
        />
        <Tab
          label="رصد جهادگران"
          value={"members"}
          sx={selectedTab === "members" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("members")}
        />
        <Tab
          label="رصد کل مراجعین"
          value={"patients"}
          sx={selectedTab === "patients" ? styleSelected : styleNotSelected}
          onClick={() => setSelectedTab("patients")}
        />
        {projectsNeededAction && projectsNeededAction.length > 0 && leader && (
          <Tab
            label="پروژه‌های نیازمند تکمیل"
            value={"neededActions"}
            sx={
              selectedTab === "neededActions" ? styleSelected : styleNotSelected
            }
            onClick={() => setSelectedTab("neededActions")}
          />
        )}
      </Tabs>
      {loading && <Loader />}

      {selectedTab === "currentTripsReport" && activeTripsStats && (
        <CurrentReport activeTripsStats={activeTripsStats} />
      )}

      {selectedTab === "allTripsInfo" && allTripsInfo && (
        <AllTripsInfo allTripsInfo={allTripsInfo} />
      )}

      {selectedTab === "members" && membersReport && (
        <GroupMembersReport membersReport={membersReport} />
      )}

      {selectedTab === "personal" && tripTables && (
        <PersonalInfo
          level={level}
          tripTables={tripTables}
          totalRecepted={totalRecepted}
        />
      )}

      {selectedTab === "patients" && patientsStat && tripTables?.trips && (
        <PatientsStat
          allTripsInfo={tripTables.trips}
          patientsStat={patientsStat}
        />
      )}

      {selectedTab === "neededActions" && (
        <ProjectsNeededAction projectsNeededAction={projectsNeededAction} />
      )}
    </>
  );
}
